/** Тип заполнения графика */
export enum CopyType {
    Quarter = 0,
    Month = 1,
    Week = 2,
}

/** Статусы дней */
export enum DateStatusEnum {
    Previous = 'prev',
    Current = 'current',
    Future = 'future',
    Closest = 'closest',
    // в интерфейсе составления графика нет статусов, присваиваем статус "плановая"
    Planned = 'planned',
}
